module.exports = __webpack_public_path__ + "img/empty@2x.5a0b226a.png";